// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"bd0642aa","453":"5a111d56","910":"7970259d"}[chunkId] + ".chunk.js";
};